// import * as L from "leaflet";
import * as R from "ramda";

import pinEasy from "../assets/images/pin-easy.svg";
import pinMedium from "../assets/images/pin-medium.svg";
import pinHard from "../assets/images/pin-hard.svg";

import pinDefault from "../assets/images/pin-default.svg";

// import pinStory from "../assets/images/pin-story.svg";
// import pinChallenge from "../assets/images/pin-challenge.svg";
// import pinExercise from "../assets/images/pin-exercise.svg";
const L = typeof window !== "undefined" ? require("leaflet") : {};

const getPin = (difficulty) =>
    difficulty === "Łatwy"
        ? pinEasy
        : difficulty === "Średni"
        ? pinMedium
        : difficulty === "Trudny"
        ? pinHard
        : undefined;

const getTaskPin = (type) => pinDefault;

export const getTaskMarkerIcon = (place) => {
    const pin = getTaskPin(place.type);
    const icon = new L.Icon({
        iconUrl: pin,
        className: "task-icon",
        iconRetinaUrl: pin,
        iconSize: new L.Point(32, 32),
        iconAnchor: new L.Point(32 / 2, 32),
    });

    return icon;
};

export const getMarkerIcon = (route, size = 64) => {
    const pin = getPin(route.difficulty.name);
    const icon = new L.Icon({
        iconUrl: pin,
        iconRetinaUrl: pin,
        iconSize: new L.Point(size, size),
        iconAnchor: new L.Point(size / 2, size),
    });

    return icon;
};

export const getColor = ({ difficulty: { name: difficulty } }) =>
    difficulty === "Łatwy"
        ? "#0038F8"
        : difficulty === "Średni"
        ? "#39A9FF"
        : difficulty === "Trudny"
        ? "#E10146"
        : undefined;

export const getActivePlaceIcon = (route) => {
    const canvas = document.createElement("canvas");
    canvas.width = 32;
    canvas.height = 32;

    const context = canvas.getContext("2d");

    const color = getColor(route);

    context.fillStyle = `${color}80`;
    context.beginPath();
    context.arc(16, 16, 16, 0, Math.PI * 2, true);
    context.fill();

    context.fillStyle = `${color}`;
    context.beginPath();
    context.arc(16, 16, 8, 0, Math.PI * 2, true);
    context.fill();

    context.fillStyle = "#FFFFFF";
    context.beginPath();
    context.arc(16, 16, 5, 0, Math.PI * 2, true);
    context.fill();

    const icon = new L.Icon({
        iconUrl: canvas.toDataURL("image/png"),
        iconRetinaUrl: canvas.toDataURL("image/png"),
        iconSize: new L.Point(32, 32),
        iconAnchor: new L.Point(16, 16),
    });

    return icon;
};

export const getCompletePlaceIcon = R.memoizeWith(R.identity, () => {
    const canvas = document.createElement("canvas");
    canvas.width = 24;
    canvas.height = 24;

    const context = canvas.getContext("2d");

    context.fillStyle = "#FFFFFF";
    context.beginPath();
    context.arc(12, 12, 12, 0, Math.PI * 2, true);
    context.fill();

    context.fillStyle = "#5c6a7b";
    context.beginPath();
    context.arc(12, 12, 11, 0, Math.PI * 2, true);
    context.fill();

    const p = new Path2D(
        "M7.906,13.985a.667.667,0,0,1-.487-.213L4.18,10.325a.667.667,0,1,1,.973-.913L7.9,12.339l5.607-6.133a.667.667,0,1,1,.987.893L8.4,13.765a.667.667,0,0,1-.487.22Z"
    );
    context.translate(1.333, 1.985);
    context.fillStyle = "#FFFFFF";
    context.fill(p);

    const icon = new L.Icon({
        iconUrl: canvas.toDataURL("image/png"),
        iconRetinaUrl: canvas.toDataURL("image/png"),
        iconSize: new L.Point(24, 24),
        iconAnchor: new L.Point(12, 12),
    });

    return icon;
});
